<template>
  <section class="weblogs-section py-5">
    <Title title="وبلاگ"></Title>
    <section class="weblogs-slider pt-5 container-md">
      <div class="swiper mySwiper p-md-2 py-2">
        <div class="swiper-wrapper">

          <div v-for="(item,index) in data" :key="index" class="swiper-slide flex-column">
            <div class="w-100">
              <div class="weblogs-slider-img"><img src="@/assets/images/gallery/photos/pic4.png" alt=""></div>
              <div class="text-right pt-3 px-3">
                 <router-link :to="'/internal-Weblog/'+item.id" type="button" class="bg-none">
                <h6 class="fontsize-medium weight-bold text-color-444">{{item.title}}</h6>
                 </router-link>
                <div>
                  <div class="">
                    <svg class="icon" height="12" width="12"><use href="@/assets/svgIcons/svgIcons.svg/#time"></use></svg>
                    <span class="text-color-666 fontsize12 mr-2">{{new Date(item.published_at).toLocaleDateString("fa")}}</span>``
                  </div>
                  <p class="text-justify fontsize-mini text-color-666 weight-light">
                    {{item.short_description.length>145?item.short_description.substring(0,145)+"...":item.short_description}}
                  </p>
                </div>
              </div>
            </div>
            <div class="text-left h-auto ml-3 mb-3 w-100">
                  <router-link :to="`/internal-Weblog/${item.id}/${item.slug}`" class="weblog-more btn-hover-bulgy2 d-inline-block bg-none rounded px-2">
                    <span class="fontsize-mini text-color-theme ml-2">بیشتر</span>
                    <svg class="icon" height="12" width="12" stroke="#30504f"><use href="@/assets/svgIcons/svgIcons.svg/#arrow-left2"></use></svg>
                  </router-link>
                </div>
          </div>

        </div>
      </div>
      <div class="swiper-button-next">
        <svg class="icon" width="35" height="35" stroke="#fff"><use href="@/assets/svgIcons/svgIcons.svg/#arrow-right-circle"></use></svg>
      </div>
      <div class="swiper-button-prev">
        <svg class="icon" width="35" height="35" stroke="#fff"><use href="@/assets/svgIcons/svgIcons.svg/#arrow-left-circle"></use></svg>
      </div>
    </section>
    <div class="text-center">
      <router-link to="/weblogs" class="weblogs-section-more btn-hover-bulgy mt-5 rounded-pill py-1 px-4">مشاهده همه</router-link>
    </div>
  </section>
</template>

<script>
import Swiper from 'swiper/swiper-bundle.min'

import Title from "./Title";
export default {
  name: "WeblogsSection",
  components:{
    Title
  },
  mounted() {
    new Swiper(".weblogs-slider .mySwiper", {
      spaceBetween: 20,
      loop:false,
      breakpoints: {
        240: {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 15,
        },
        450:{
          slidesPerView: 2,
          centeredSlides: true,
          spaceBetween: 32,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        992:{
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },
      navigation: {
        nextEl: ".weblogs-slider .swiper-button-next",
        prevEl: ".weblogs-slider .swiper-button-prev",
      },
    });

    document.querySelectorAll('.weblogs-slider-img').forEach(item=>{
      item.style.height = item.offsetWidth/1.2 + 'px'
    })


    let slideH = document.querySelector('.weblogs-slider .swiper-slide').offsetHeight;
    document.querySelectorAll('.weblogs-slider .swiper-slide').forEach((item2)=> {
      if (slideH < item2.offsetHeight){
        slideH = item2.offsetHeight
      }
    })
    document.querySelectorAll('.weblogs-slider .swiper-slide').forEach((item)=>{
      item.style.height = slideH + 'px'

    })

    if (window.innerWidth < 768){
      document.querySelector('.weblogs-section-more').classList.remove('btn-hover-bulgy');
    }
  },
  props:{
    data:Array
  }
}
</script>

<style scoped>
.weblogs-section{
  box-shadow: 0 0 5px #0003;
  /*position: relative;*/
}
.weblogs-slider{
  margin:30px auto;
  position: relative;
}
.weblogs-slider .swiper-slide{
  box-shadow: 0 0 6px #6664;
  border-radius: 20px;
  background-color: white;
  /*height: 417px;*/
  flex-direction: column;
  justify-content: space-between;
}
.weblogs-slider-img{
  border-radius: 20px;
  width: 100%;
  overflow: hidden;
}
.weblogs-slider-img img{
  width: 100%;
  height: 100%;
}
.swiper-button-next::after, .swiper-rtl .swiper-button-prev::after , .swiper-button-prev::after, .swiper-rtl .swiper-button-next::after {
  content: '';
}
.swiper-button-next, .swiper-button-prev {
  width: unset;
}
.swiper-button-next, .swiper-rtl .swiper-button-prev{
  right: -30px;
}
/* .swiper-button-prev, .swiper-rtl .swiper-button-next{
  left: -30px;
} */
.swiper-button-next svg, .swiper-button-prev svg{
  fill: #8a8a8a ;
}
.swiper-button-next svg:hover, .swiper-button-prev svg:hover{
  fill: #333 !important;
}
.weblog-more:hover{
  border: 1px solid var(--color-themeOp);
}
.weblogs-section-more{
  border: 1px solid var(--color-theme);
  background: none;
  color: var(--color-theme);
  margin: 30px auto;
}
@media screen and (max-width: 1199px){
  .swiper-button-next, .swiper-rtl .swiper-button-prev{
    right: -15px;
  }
  .swiper-button-prev, .swiper-rtl .swiper-button-next{
    left: -15px;
  }
  .weblogs-slider .swiper-slide{
    /*height: 375px;*/
  }
}
@media screen and (max-width: 991px){
  .weblogs-slider .swiper-slide {
    /*height: 382px;*/
  }
}
@media screen and (max-width: 767px){
  .swiper-button-next, .swiper-button-prev {
    display: none;
  }
  .weblogs-section-more{
    background-color: var(--color-theme);
    color: white;
    box-shadow: 0 3px 3px #0003 inset;
  }
  /*.weblogs-slider .swiper{*/
  /*  padding-right: 25%;*/
  /*  padding-left: 25%;*/
  /*}*/
}
@media screen and (max-width: 449px) {
  .weblogs-slider .swiper{
    padding-right: 0;
    padding-left:5rem;
  }
}
</style>